import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import close from '../../../../assets/images/bluecross.svg';
import warning from '../../../../assets/images/warning.svg';

export default function AddRoleModal(props) {
  const {
    handleToggleModalState,
    parentModalState,
    handleAddRole,
    resetFormValues,
    roleTitleShowError,
    roleIndustryShowError,
    roleLocationShowError,
    validateForm
  } = props;

  const handleModalStateChange = () => {
    handleToggleModalState(!parentModalState);
    resetFormValues();
  }

  const handleFormSubmit = async (event) => {
    console.log('working');
    console.log(event);
    // Prevent the default form submission behavior
    event.preventDefault();

    const formData = new FormData(event.target);
    console.log(formData);

    // Convert Form Data to an object
    const formDataObject = {};
    formData.forEach((value, key) => {
      formDataObject[key] = value;
    });

    for (const [key, value] of formData.entries()) {
      console.log(key, value);
    }

    const validation = validateForm(formDataObject);

    if (validation.role_title === false
      // && validation.role_industry === false && validation.role_location === false
    ) {
      await handleAddRole(formDataObject);
      handleModalStateChange();
    }
  };

  return createPortal((
    <section className='add-role-modal'>
      <div className='background' />
      <div className='add-role-modal__inner'>
        <img src={close} onClick={handleModalStateChange} alt="Close" />
        <div className="form-container">
          <h2>Add a Role</h2>
          <form onSubmit={handleFormSubmit}>
            {roleTitleShowError === true && <div className="alert-box"><img src={warning} alt="Warning"></img></div>}
            <input
              type="text"
              name="role_title"
              id="role_title"
              placeholder="Role Title"
              className="role-input"
            />
            <div className="form-control">
              <button type="submit">Add a Role</button>
            </div>
          </form>
        </div>
      </div>
    </section >
  ), document.body);
}
